/**
 * UI-related translations for Russian language
 * This file contains translations for common UI elements
 */
export default {
  startPanel: {
    copyLink: 'Ссылка',
    discord: 'Discord',
    leaveGame: 'Покинуть игру',
    joinGame: 'Присоединиться',
    lockGame: 'Закрыть игру',
    unlockGame: 'Открыть игру',
    startGame: 'Начать игру',
    options: 'Настройки',
  },
  onlineStatus: {
    connecting: 'Подключение...',
    connected: 'Онлайн',
    error: 'Ошибка',
  },
  profile: {
    username: 'Имя пользователя',
    stats: 'Статистика',
    logout: 'Выйти',
    language: 'Язык',
    hideSpoilersHint: 'Скрыть спойлеры',
    hideIndexHint: 'Скрывать индексы в истории',
    animeMode: 'Аниме-режим',
    update: 'Обновить',
    colorTheme: 'Цветовая тема',
    darkTheme: 'Тёмная тема',
    lightTheme: 'Светлая тема',
    profile: 'Профиль',
    settings: 'Настройки',
    change: 'Изменить',
    changePassword: 'Изменить пароль',
  },
  breadCrumbs: {
    merlin: 'Мерлин',
    merlin_pure: 'Белый Мерлин',
    guinevere: 'Гвиневра',
    percival: 'Персиваль',
    lovers: 'Любовники',
    troublemaker: 'Траблмейкер',
    servant: 'Сервант',
    lancelots: 'Ланселоты',
    mordred: 'Мордред',
    trickster: 'Трикстер',
    revealer: 'Разоблаченная',
    morgana: 'Моргана',
    oberon: 'Оберон',
    lunatic: 'Лунатик',
    brute: 'Брут',
    witch: 'Ведьма',
    minion: 'Миньон',
    cleric: 'Клирик',
    wiki: 'Вики',
    expansions: 'Дополнения',
    roles: 'Роли',
    lady: 'Леди озера',
    lady_sea: 'Леди моря',
    plot_cards: 'Сюжетные карты',
    excalibur: 'Экскалибур',
    rules: 'Правила',
  },
  hostMenu: {
    host: 'Админ',
    hostPanel: 'Админ панель',
    endRestartGameHint: 'Кнопки используются для голосования за окончание или перезапуск игры',
    endGame: 'Закончить игру',
    restartGame: 'Перезапустить игру',
    shuffle: 'Перемешать',
    shuffleHint: 'Перемешать игроков в лобби',
  },
  cardsInfo: {
    cards: 'Карты',
    usedCards: 'Использованные карты',
    remainingCards: 'Оставшиеся карты',
    leadToVictory: 'Привести к победе',
    leadToVictoryHint: 'Стать лидером перед выбором команды',
    ambush: 'Засада',
    ambushHint: 'Раскрыть результат одной карты из похода',
    kingReturns: 'Король возвращается',
    kingReturnsHint: 'Отменить одобренную миссию и передать лидерство следующему игроку',
    restoreHonor: 'Восстанови свою честь',
    restoreHonorHint: 'Взять сюжетную карту у любого игрока',
    charge: 'Иду на вы',
    chargeHint: 'Заставить игрока голосовать публично',
    showNature: 'Покажи свою истинную суть',
    showNatureHint: 'Раскрыть свою лояльность другому игроку',
    areYouTheOne: 'Ты тот самый',
    areYouTheOneHint: 'Проверить лояльность соседнего игрока',
    weFoundYou: 'Мы нашли тебя',
    weFoundYouHint: 'Заставить одного игрока сыграть карту похода открыто',
    showStrength: 'Покажи свою силу',
    showStrengthHint: 'Лидер раскрывает свою лояльность игроку',
  },
  avatars: {
    modalHeader: 'Выбор аватара',
    servantHint: 'Стандартный аватар',
    lady_of_lakeHint: 'Вручается пользователям, зарегистрированным в 2025 году',
    mysteryHint: 'Выдается пользователям, нашедшим секрет на сайте',
    merlin_pureHint: 'Вручается за помощь проекту с отзывами / помощь в поиске ошибок',
    'anime/merlin_pureHint': 'Вручается за любой вклад в код проекта на GitHub',
    'anime/witchHint': 'Вручается за достижение топ-1 рейтинга на любой роли',
  },
  spoiler: {
    spoiler: 'Спойлер',
    spoilerHint: 'Контент скрыт под спойлером, так как содержит информацию, неизвестную другим игрокам',
  },
  previewLink: {
    'Minions of Mordred(*)': 'Приспешники Мордреда(*)',
    Minions: 'Приспешники',
  },
  chartStats: {
    countPlayer: '{playerCount} игроков',
    evilWinrate: 'Процент побед Сил Тьмы',
    goodWinrate: 'Процент побед Сил Света',
    winrateByTeamSize: 'Процент побед в зависимости от размера команды',
    halfWinrate: '50% побед',
  },
  inGame: {
    sendTeam: 'Отправить поход',
    approve: 'За',
    reject: 'Против',
    success: 'Успех',
    fail: 'Провал',
    checkLoyalty: 'Проверить лояльность',
    giveExcalibur: 'Дать Экскалибур',
    skipExcalibur: 'Пропустить Экскалибур',
    useExcalibur: 'Применить Экскалибур',
    useWitchAbility: 'Скрыть поход',
    skipWitchAbility: 'Пропустить',
    giveCard: 'Передать карту',
    takeLead: 'Взять лидерство',
    skip: 'Пропустить',
    useCard: 'Использовать {cardName}',
    skipCard: 'Пропустить {cardName}',
    selectPlayer: 'Выберите игрока',
    selectSinglePlayer: 'Пожалуйста, выберите только одного игрока',
    cannotSelectSelf: 'Вы не можете выбрать себя',
    takeCard: 'Взять карту',
    selectCard: 'Выберите карту',
    noAvailableCards: 'Нет доступных карт',
    revealLoyalty: 'Показать лояльность',
  },
};
